import { ICameraImage } from '@models/ICameraImage';
import ImageLightBox from '@molecules/ImageLightBox/ImageLightBox';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props extends ICameraImage {
  readonly className?: string;
  readonly isDoubleSize?: boolean;
  readonly gap: number;
  readonly width: number;
  readonly contentIds: string[];
  readonly dataTestId?: string;
}

const ImageMasonryItem = ({
  className,
  isDoubleSize = false,
  gap,
  width,
  dataTestId,
  ...props
}: Props) => {
  const { image, componentName } = props;
  const isBelowXLargeDesktop = useMediaQuery(1900);
  if (!image?.desktop?.url) return null;

  // (original height / original width) x new width = new height
  const calculatedHeight = Math.floor(
    (image.desktop.height / image.desktop.width) * width
  );
  const height =
    !isBelowXLargeDesktop && isDoubleSize
      ? calculatedHeight * 2
      : calculatedHeight;

  return (
    <div
      tabIndex={-1}
      data-name={componentName}
      className={classNames('overflow-hidden', className)}
      style={{ marginBottom: `${gap}px`, height }}
      data-testid={dataTestId}
    >
      <ImageLightBox
        {...props}
        imageClasses="aspect-auto h-full w-full"
        showImageDataByDefault
      />
    </div>
  );
};

export default ImageMasonryItem;
